import type { ComponentProps, ReactNode } from "react";

type TextFieldProps = ComponentProps<"input"> & {
  /** Visual content rendered at the right edge of the field (icon, toggle, required mark). */
  adornment?: ReactNode;
  /** Paint the field red and float the message on the top border, the way
      the edit-form `Field` floats its label. */
  error?: string;
};

export default function TextField({
  adornment,
  error,
  className = "",
  "aria-label": ariaLabel,
  placeholder,
  ...props
}: TextFieldProps) {
  return (
    <div className="relative w-full">
      <input
        className={`w-full rounded-full border-2 bg-white py-3.5 pl-6 font-sans text-base font-light text-ink placeholder:text-ink/50 focus:outline-none focus:ring-2 ${error ? "border-deep-red focus:border-deep-red focus:ring-deep-red/30" : "border-ink focus:border-steel focus:ring-steel/30"} ${adornment ? "pr-12" : "pr-6"} ${className}`}
        aria-invalid={error ? true : undefined}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        {...props}
      />
      {adornment && (
        <span className="-translate-y-1/2 absolute top-1/2 right-5 flex items-center text-ink/60">
          {adornment}
        </span>
      )}
      {error && (
        <span className="-top-2 absolute left-6 bg-white px-1.5 font-sans text-xs text-deep-red">
          {error}
        </span>
      )}
    </div>
  );
}
